import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getReviews = () => {
  return axios.get('/reviews');
};

export const useReviews = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['reviews'],
    queryFn: () => getReviews(),
  });
};
